module.exports = __webpack_public_path__ + "images/mazdacf8bb7fd4d3d7816fc3dd7ed1e9cb1bc.png";